import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import ThemeContextWrapper from './ThemeProvider/themeContextWrapper';
import CustomCursor from 'custom-cursor-react';
import 'custom-cursor-react/dist/index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeContextWrapper>
    <Router>
      <CustomCursor
        targets={['a', 'button', '.discover-more']}
        customClass='custom-cursor'
        dimensions={50}
        fill='#20E1D7'
        smoothness={{movement: 1, scale: 0.05, opacity: 0.3}}
        targetOpacity={.4}/>
        <App />
    </Router>
  </ThemeContextWrapper>
);

